const locale = {
  placeholder: '选择时间段',
  label_last6Hours: '最近 6 小时',
  label_last24Hours: '最近 24 小时',
  label_last2Days: '最近 2 天',
  label_last3Days: '最近 3 天',
  label_last7Days: '最近 7 天',
  label_last15Days: '最近 15 天',
  label_last30Days: '最近 30 天',
  label_weekToCurrentDate: '周初至今',
  label_monthToCurrentDate: '月初至今',
  label_today: '今天',
  label_currentMonth: '当前月',
  label_custom: '自定义时间段',
  label_timeZone: '时区',
  label_localTime: '本地时间',
  startTimeError: '时间不能早于 {earliestTime}',
  endTimeError: '时间不能晚于 {latestTime}',
  rangeError: '时间跨度不能超过',
  label_from: '从',
  label_to: '到',
  button_apply: '应用',
  label_otherActions: '快速设置',
  label_yesterday: '昨天',
  label_previousWeek: '上个星期',
  label_previousMonth: '上个月'
};
export default locale;